module.exports = __webpack_public_path__ + "video/3400_CT_2022_Credential-Harvesting_Attack.5f7503ed.vtt";